import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { uniqueId, cx } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as progressMeterStyles };

var _excluded = ["className", "id", "max", "value", "inverse", "steps", "size", "title", "color", "noPadding"];
var LinearProgressMeter = function (_ref) {
  var className = _ref.className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? uniqueId('linearProgressMeter_') : _ref$id,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 0 : _ref$max,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    steps = _ref.steps,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    title = _ref.title,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'accent1' : _ref$color,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isSizeSmall = size === 'sm';
  var labelClasses = cx(styles.label, inverse && styles.inverseLabel, isSizeSmall && styles.sizeSmLabel);
  var progressMeterClasses = cx(styles.base, function colorClassMap(color) {
    var _styles$progressMeter;
    return (_styles$progressMeter = styles.progressMeterColors[color]) !== null && _styles$progressMeter !== void 0 ? _styles$progressMeter : styles.progressMeterColors.accent1;
  }(color), isSizeSmall && styles.sizeSm, noPadding && styles.noPadding, className);
  var progressClasses = cx(styles.progressClasses, styles.progressMeterColors[color], Number(value) > 0 && styles.minWidth);
  var stepsClasses = cx(styles.steps, isSizeSmall && styles.sizeSmLabelSteps, isSizeSmall && inverse && styles.sizeSmInverseLabelSteps);
  var titleClasses = cx(!inverse && styles.labelTitle, isSizeSmall && styles.sizeSmLabelTitle, isSizeSmall && inverse && styles.sizeSmInverseLabelTitle);
  return /*#__PURE__*/React.createElement("div", {
    className: progressMeterClasses,
    "data-ppui-info": "linear-progress-meter_1.2.3__8.12.0"
  }, /*#__PURE__*/React.createElement("progress", _extends({
    className: progressClasses,
    id: id,
    max: max,
    value: value
  }, rest, {
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("label", {
    className: labelClasses,
    htmlFor: id,
    "data-ppui": "true"
  }, steps && /*#__PURE__*/React.createElement("span", {
    className: stepsClasses,
    "data-ppui": "true"
  }, steps), title && /*#__PURE__*/React.createElement("span", {
    className: titleClasses,
    "data-ppui": "true"
  }, title)));
};

export { LinearProgressMeter };
